module.exports = __webpack_public_path__ + "static/media/9-4.1b05121d.mp3";